export default __webpack_public_path__ + "static/media/04.757cd6f7.png";